module.exports = __webpack_public_path__ + "8878562d1162d14eb9736da7e1b9835f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/theater-2015.jpg
// module id = 677
// module chunks = 0